/**
 * Demo playbook hint for Okta workspaces (POST-ARC.11b — T1-5).
 *
 * @param {{ hasSnapshot?: boolean }} props
 */
export default function OktaDemoPlaybookBanner({ hasSnapshot = false }) {
  if (!hasSnapshot) return null;

  return (
    <div className="border-b border-sky-500/20 bg-sky-500/10 px-4 py-2 text-center text-xs text-sky-100/90">
      <span className="font-medium">Demo tip:</span> For live pitches, use your latest snapshot below —
      avoid re-running org-audit during the demo to reduce Okta rate-limit risk and wait time.
    </div>
  );
}
